import { jsxs as at, jsx as I } from "react/jsx-runtime";
import E from "react";
import { useI18n as dt } from "next-localization";
import { useFormContext as lt, useForm as ct, FormProvider as pt } from "react-hook-form";
import { g as ut } from "./use-maps-token.mGyQNmhc.js";
import { U as s, u as Et, c as yt, a as Ct, g as gt } from "./use-search-address.UauY9Cwh.js";
import { u as Tt } from "./use-url-query-params.BeS0y6L0.js";
import { NeuButton as ht } from "@hcahealthcaredpx/neutron-react";
import { ConditionalWrap as It } from "../components/conditional-wrap/index.js";
import { T as St, M as mt } from "./Typeahead.RUczeL1X.js";
const Rt = "use-my-location-button", Ut = /^[a-zA-Z0-9()\-–',.&\s]+$/, Z = "use-my-location-button", Ot = ({
  className: $,
  id: j,
  name: f,
  placeholder: q,
  popperStrategy: G,
  autofillStoredLocation: Y = !0,
  searchedAddressOverride: y,
  disabled: R,
  label: X,
  searchParams: g,
  onSelectLocation: F,
  selectFirstItemOnBlur: W = !1
}) => {
  const { t: S } = dt(), { queryParams: a, isReady: O } = Tt(), [M, z] = E.useState(void 0), [J, m] = E.useState(null), r = f && !Object.values(s).includes(
    f
  ) ? f : s.ADDRESS, {
    userLocation: e,
    loading: N,
    error: C,
    setError: K,
    onUseMyLocationClick: Q
  } = Et(), [n] = yt(), U = (t) => {
    var i;
    return (i = g == null ? void 0 : g.entityType) != null && i.includes("PostalCodeArea") && t.city && t.state ? `${t.city}, ${t.state}${t.zipCode ? " " + t.zipCode : ""}` : t.address || "";
  }, B = E.useRef(!0), D = (t) => {
    if (!t && !B.current) {
      o(s.ADDRESS, ""), o(s.CITY, ""), o(s.STATE, ""), o(s.ZIP_CODE, ""), o(s.LATITUDE, ""), o(s.LONGITUDE, "");
      return;
    }
    u && (B.current = !1);
    const i = t && U(t);
    i && o(r, i), o(s.CITY, (t == null ? void 0 : t.city) ?? ""), o(s.STATE, (t == null ? void 0 : t.state) ?? ""), o(s.ZIP_CODE, (t == null ? void 0 : t.zipCode) ?? ""), o(s.LATITUDE, (t == null ? void 0 : t.latitude) ?? ""), o(s.LONGITUDE, (t == null ? void 0 : t.longitude) ?? "");
  }, w = lt(), k = ct({
    defaultValues: {
      [r]: "",
      [s.CITY]: "",
      [s.STATE]: "",
      [s.ZIP_CODE]: "",
      [s.LATITUDE]: "",
      [s.LONGITUDE]: ""
    }
  }), p = w || k, { setValue: o, register: L, watch: V } = p, {
    typeaheadData: P,
    setLocationSearchParameter: b,
    isLoading: x,
    error: H
  } = Ct(g || {});
  E.useEffect(() => {
    if (e != null && e.address && (e != null && e.longitude) && (e != null && e.latitude) && (e != null && e.city) && (e != null && e.state) && (e != null && e.zipCode)) {
      m({
        id: "userLocation",
        data: e,
        value: U(e)
      }), D(e);
      return;
    }
  }, [
    e,
    e == null ? void 0 : e.address,
    e == null ? void 0 : e.city,
    e == null ? void 0 : e.state,
    e == null ? void 0 : e.zipCode,
    e == null ? void 0 : e.latitude,
    e == null ? void 0 : e.longitude
  ]);
  const tt = !!(y && y.address && y.latitude && y.longitude);
  E.useEffect(() => {
    if (O && Y && !N && !x && B.current) {
      const t = a && a.address ? {
        address: a.address || void 0,
        city: a.city || void 0,
        state: a.state || void 0,
        zipCode: a.zip || void 0,
        latitude: a.latitude || void 0,
        longitude: a.longitude || void 0
      } : {
        address: n == null ? void 0 : n.address,
        city: n == null ? void 0 : n.city,
        state: n == null ? void 0 : n.state,
        zipCode: n == null ? void 0 : n.zipCode,
        latitude: n == null ? void 0 : n.latitude,
        longitude: n == null ? void 0 : n.longitude
      }, i = y && tt ? y : t;
      m({
        id: "storedLocation",
        data: i,
        value: U(i)
      }), D(i);
    }
  }, [a, O]), E.useEffect(() => {
    C ? p.setError(r, {
      type: "manual",
      message: C
    }) : p.clearErrors(r);
  }, [C, p, r]);
  const et = async () => {
    N || (await Q()).forceAutofill && e && (m({
      id: "userLocation",
      data: e,
      value: U(e)
    }), D(e));
  }, it = q ?? S("Locations.Search.Form.EnterLocationPlaceholder"), nt = X ?? S("Search.EnterLocation"), st = (t) => {
    !M && t && b({
      ...g,
      query: t
    });
  }, u = V(r);
  E.useEffect(() => {
    if (!u || Ut.test(u) && u.trim())
      u || b({ query: void 0 }), z(void 0), p.clearErrors(r);
    else if (u.trim()) {
      const t = S("Search.Errors.InvalidSpecialCharacters");
      z(t), p.setError(r, {
        type: "manual",
        message: t
      });
    } else {
      const t = "Field must have at least 1 non-space character";
      z(t), p.setError(r, {
        type: "manual",
        message: t
      });
    }
  }, [u]);
  const ot = L(r), rt = (t) => {
    const i = P ?? [], d = t.relatedTarget, A = () => !!(d && d.closest(".typeahead") && i.length > 1), _ = () => {
      var c;
      return !!(d && ((c = d.closest("button")) == null ? void 0 : c.id) === Z);
    }, v = () => {
      var c;
      return !!(d && ((c = d.closest("button")) != null && c.classList.contains("neu-search-clear")));
    }, T = () => W && i.length > 0, l = () => !!document.querySelector(".typeahead .unit-dropdown");
    if (A() || _() || v())
      return;
    const h = () => {
      const c = i[0];
      c && !c.isHeader && m(c);
    };
    T() && l() && h();
  };
  return /* @__PURE__ */ at("div", { className: $, children: [
    /* @__PURE__ */ I("div", { className: "position-relative", children: /* @__PURE__ */ I(
      ht,
      {
        className: "position-absolute position-right",
        kind: "tertiary",
        onNeuClick: et,
        icon: "location_on",
        size: "small",
        disabled: R,
        id: Z,
        children: S("Locations.Search.Form.UseMyLocation")
      }
    ) }),
    /* @__PURE__ */ I(
      It,
      {
        condition: !w,
        wrapper: (t) => /* @__PURE__ */ I(pt, { ...k, children: t }),
        wrappedJSX: /* @__PURE__ */ I(
          St,
          {
            className: "optional-none",
            itemsLoading: N || x,
            invalid: C || H || M,
            error: C || H || M,
            disabled: R,
            id: j,
            items: P ?? [],
            placeholder: it,
            label: nt,
            onTypeaheadKeyPress: (t) => {
              t && t.trim() && t.length >= mt && st(t), C && K(void 0);
            },
            onSelected: async (t) => {
              var d, A;
              const i = t ? { ...t.data } : null;
              if (i && !i.zipCode) {
                const _ = gt(i.latitude, i.longitude), v = await ut();
                if (_ && v) {
                  const T = await fetch(_, {
                    headers: {
                      Authorization: `Bearer ${v}`,
                      "x-ms-client-id": process.env.NEXT_PUBLIC_AZURE_MAPS_CLIENT_ID || ""
                    }
                  }).then((h) => h.json()).then((h) => h), l = (A = (d = T == null ? void 0 : T.addresses) == null ? void 0 : d[0]) == null ? void 0 : A.address;
                  l && (l != null && l.postalCode) && (i.zipCode = l == null ? void 0 : l.postalCode);
                }
              }
              D(i), F == null || F(i);
            },
            selectItem: J,
            ...ot,
            popperStrategy: G,
            onNeuBlur: rt
          }
        )
      }
    )
  ] });
};
export {
  Ot as U,
  Ut as V,
  Rt as a
};
